import {
    chakra, Box
} from '@chakra-ui/react';

/**
 * Content overlay needs to still allow the header to be used, eg top offset.
 */
export const ContentOverlayBackground = chakra(Box, {
    label: 'ContentOverlayBackground',
    baseStyle: {
        top: '60px',
        position: 'fixed',
        left: '0',
        zIndex: '3',
        h: 'calc(100vh - 60px)',
        w: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'neutral.50',
        opacity: '.95'
    }
});

export const OverlayContentBackground = chakra(Box, {
    label: 'OverlayContentBackground',
    baseStyle: {
        flexDirection: 'column',
        textAlign: 'center',
        mt: '60px',
        ['& > *']: { mb: '10px' },
        ['p']: {
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '24px',
            textAlign: 'center'
        }
    }
});

export const NewOverlayContentBackground = chakra(Box, {
    label: 'OverlayContentBackground',
    baseStyle: {
        flexDirection: 'column',
        textAlign: 'center',
        mt: '60px',
        ['& > *']: { mb: '10px' },
        h: '100%',
        overflow: 'auto',
        w: '100%'
    }
});
